'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Ajax = require('../xhr');
var Url = require('../util/url');
var Extend = require('../util/extend');
var version = require('../constant/version').version;
var Logger = require('../util/logger');

var NAME = 'page';

/**
 * 页面性能管理
 * 
 * @class PageManager
 */

var PageManager = function () {
    /**
     * Creates an instance of PageManager.
     * @param {CfgManager} cfgManager 
     * @memberof PageManager
     */
    function PageManager(cfgManager) {
        _classCallCheck(this, PageManager);

        this.noCache = false;
        this.points = [];
        this.pointsCustom = [];
        this.cfgManager = cfgManager;
    }

    _createClass(PageManager, [{
        key: 'setUserReady',
        value: function setUserReady() {
            this.cfgManager.set({
                page: {
                    auto: true
                }
            });
        }
        /**
         * 判断系统是否ready发送页面性能
         * 
         * @returns 
         * @memberof PageManager
         */

    }, {
        key: 'getUserReady',
        value: function getUserReady() {
            return this.cfgManager.get(NAME).auto;
        }
    }, {
        key: 'setReady',
        value: function setReady() {
            this.isReady = true;
        }
        /**
         * 判断用户是否ready发送页面性能
         * 
         * @returns 
         * @memberof PageManager
         */

    }, {
        key: 'getReady',
        value: function getReady() {
            return this.isReady;
        }

        /**
         * 获得性能时间
         * @override
         * @memberof PageManager
         */

    }, {
        key: 'getPerformaceTiming',
        value: function getPerformaceTiming() {
            return {
                perf: window.performance && window.performance.timing,
                paint: window.performance && window.performance.getEntriesByType && window.performance.getEntriesByType('paint')
            };
        }
        /**
         * 获得资源型时间
         * @override
         * @memberof PageManager
         */

    }, {
        key: 'getMainResourceTiming',
        value: function getMainResourceTiming() {
            var resourceTiming = window.performance && window.performance.getEntriesByType && window.performance.getEntriesByType('resource');
            var filter = this.cfgManager.get('page').isMainResource;

            var mainResourceTiming = [];

            try {
                if (!resourceTiming) return;

                if (typeof filter === 'function') {
                    for (var index = 0; index < resourceTiming.length; index++) {
                        var element = resourceTiming[index];
                        if (filter(element)) {
                            mainResourceTiming.push(element);
                        }
                    }
                    return mainResourceTiming;
                } else {
                    for (var _index = 0; _index < resourceTiming.length; _index++) {
                        var resource = resourceTiming[_index];
                        if (resource.initiatorType === 'link' || resource.initiatorType === 'script') {
                            mainResourceTiming.push(resource);
                        }
                    }
                    //  前N个核心资源
                    var size = this.cfgManager.get('page').mainResourceNumber;
                    if (mainResourceTiming.length <= size) {
                        return mainResourceTiming;
                    } else {
                        return mainResourceTiming.splice(0, size);
                    }
                }
            } catch (e) {
                Logger.ignore(e);
            }
        }
    }, {
        key: 'parsePageTimeWithDefer',
        value: function parsePageTimeWithDefer() {
            var _this = this;

            setTimeout(function () {
                _this.parsePageTime();
            }, 0);
        }
        /**
         * 解析页面性能点数据
         * 
         * @memberof PageManager
         */

    }, {
        key: 'parsePageTime',
        value: function parsePageTime() {

            var timing = this.getPerformaceTiming();

            var perf = timing.perf,
                paint = timing.paint;

            if (!perf) {
                return this.setReady();
            }

            var navStart = perf.navigationStart;

            var perfMap = {
                unloadEventStart: 1,
                unloadEventEnd: 2,
                redirectStart: 3,
                redirectEnd: 4,
                fetchStart: 5,
                domainLookupStart: 6,
                domainLookupEnd: 7,
                connectStart: 8,
                connectEnd: 9,
                requestStart: 10,
                responseStart: 11,
                responseEnd: 12,
                domLoading: 13,
                domInteractive: 14,
                domContentLoadedEventStart: 15,
                domContentLoadedEventEnd: 16,
                domComplete: 17,
                loadEventStart: 18,
                loadEventEnd: 19
            };

            var perfKey = void 0;
            for (perfKey in perf) {
                if (perf[perfKey] === 0) {
                    this.points[perfMap[perfKey]] = perf[perfKey];
                } else {
                    this.points[perfMap[perfKey]] = perf[perfKey] - navStart;
                }
            }

            //  默认添加统计数据
            this.points[20] = perf.domainLookupEnd - perf.domainLookupStart; //dns查询时间
            this.points[21] = perf.connectEnd - perf.connectStart; //tcp链接时间
            this.points[22] = perf.responseEnd - perf.requestStart; //请求响应时间

            //  渲染时间采集
            if (paint && paint.length) {
                try {
                    var _parseInt = Number.parseInt || window.parseInt;
                    var firstPaint = void 0;
                    var firstContentfulPaint = void 0;
                    for (var index = 0; index < paint.length; index++) {
                        var element = paint[index];

                        if (element.name === 'first-paint') {
                            firstPaint = _parseInt(element.startTime);
                        } else if (element.name === 'first-contentful-paint') {
                            firstContentfulPaint = _parseInt(element.startTime);
                        }
                    }
                    if (firstPaint && firstContentfulPaint) {
                        this.points[23] = firstPaint;
                        this.points[24] = firstContentfulPaint;
                    }
                } catch (e) {
                    Logger.ignore(e);
                }
            }

            //  处理异常数据
            for (var i = 0; i < this.points.length; i++) {
                if (isNaN(this.points[i])) {
                    this.points[i] = 0;
                }
            }

            //  判断是否是首次加载
            var resTiming = this.getMainResourceTiming();
            if (resTiming) {
                var noCache = this.noCache;
                for (var _index2 = 0; _index2 < resTiming.length; _index2++) {
                    var resource = resTiming[_index2];

                    //  iOS不支持transferSize字段
                    if (resource.transferSize !== undefined) {
                        if (resource.transferSize !== 0) {
                            noCache = true;
                        }
                    } else if (resource.duration !== undefined) {
                        var timeThreshold = this.cfgManager.get('page').timeThreshold;
                        if (resource.duration > timeThreshold) {
                            noCache = true;
                        }
                    }
                }
                this.noCache = noCache;
            }

            this.setReady();
            this.report();
        }
        /**
         * 增加业务自定义性能点
         * 
         * @param {Object} point 
         * @param {Number} point.position
         * @param {Number} point.duration
         * @memberof PageManager
         */

    }, {
        key: 'push',
        value: function push(point) {
            if (this.onPush) {
                this.onPush(point);
            }
            if (!point || typeof point.position !== 'number') return;

            if (point.position < 0 || point.position > 31) return;

            this.pointsCustom[point.position] = point.duration;

            this.report();
        }
    }, {
        key: 'clearTimeout',
        value: function (_clearTimeout) {
            function clearTimeout() {
                return _clearTimeout.apply(this, arguments);
            }

            clearTimeout.toString = function () {
                return _clearTimeout.toString();
            };

            return clearTimeout;
        }(function () {
            clearTimeout(this.timeout);
            this.timeout = undefined;
        })
        /**
         * 上报性能点
         * 
         * @memberof PageManager
         */

    }, {
        key: 'report',
        value: function report(isReoprtNow) {
            var _this2 = this;

            var cfgManager = this.cfgManager;

            if (!this.getReady()) return;

            if (!this.getUserReady()) return;

            if (!this.points.length && !this.pointsCustom.length) return;

            //  控制性能的采样率
            if (Math.random() > cfgManager.get(NAME).sample) return;

            if (this.onSubmit) {
                this.onSubmit(this.points, this.pointsCustom);
            }

            try {
                if (this.timeout) {
                    this.clearTimeout();
                } else if (this.pendingAjax && this.pendingAjax.abort) {
                    this.pendingAjax.abort();
                }
            } catch (e) {
                Logger.ignore(e);
            }

            var doSend = function doSend() {

                _this2.clearTimeout();

                if (!_this2.points.length && !_this2.pointsCustom.length) return;

                var apiPath = cfgManager.getApiPath(NAME);

                var url = Url.stringify(apiPath);

                var ext = cfgManager.getExtension();

                var data = Extend({
                    project: cfgManager.get('project'),
                    pageurl: encodeURIComponent(cfgManager.get('pageUrl')),
                    speed: encodeURIComponent(_this2.points.join('|')),
                    customspeed: encodeURIComponent(_this2.pointsCustom.join('|')),
                    timestamp: +new Date(),
                    sdk: version,
                    noCache: _this2.noCache ? 'true' : 'false'
                }, ext);

                //  页面性能无需关心unionId信息
                delete data.unionId;

                url = Url.stringify(url, data);
                _this2.pendingAjax = Ajax({
                    method: 'GET',
                    url: url,
                    success: function success() {
                        //清空数据
                        _this2.points = [];
                        _this2.pointsCustom = [];
                        _this2.pendingAjax = undefined;
                    }
                });
            };

            var delay = cfgManager.get(NAME).delay || 0;
            if (isReoprtNow) {
                doSend();
            } else if (delay >= 0) {
                this.timeout = setTimeout(function () {
                    doSend();
                }, delay);
            }
        }
    }]);

    return PageManager;
}();

module.exports = PageManager;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/owl/lib/page/index.js
// module id = 251
// module chunks = 0